export const desktopMenuBreakpoint = '(min-width: 769px)';
export const desktopSettingsMenuBreakpoint = '(min-width: 992px)';
export const xsBreakpoint = '(max-width: 576px)';
export const floorPlanRightSidebarBreakpoint = '(max-width: 1400px)';
